module.exports = __webpack_public_path__ + "media/components/src/assets/images/order-gift-packaging/sample-momotaro-img_b-0dbfdcf832d7eb74e9369e9a307e9b92.png";